import { render, staticRenderFns } from "./MessengerToggle.vue?vue&type=template&id=061c46c4&scoped=true"
import script from "./MessengerToggle.vue?vue&type=script&lang=js"
export * from "./MessengerToggle.vue?vue&type=script&lang=js"
import style0 from "./MessengerToggle.vue?vue&type=style&index=0&id=061c46c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061c46c4",
  null
  
)

export default component.exports